module.exports = __webpack_public_path__ + "media/brands/PXL_20240411_144657797-5fa59965.jpg";